import { render } from "./BranchDonutComparisonBlock.vue?vue&type=template&id=0123af8d&scoped=true"
import script from "./BranchDonutComparisonBlock.vue?vue&type=script&lang=js"
export * from "./BranchDonutComparisonBlock.vue?vue&type=script&lang=js"

import "./BranchDonutComparisonBlock.vue?vue&type=style&index=0&id=0123af8d&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0123af8d"]])

export default __exports__